import R from 'ramda'
import invariant from './invariant'

const range = (start, end, step) => {
  let r = []
  for(let i = start; i < end; i += step){
    r.push(i)
  }
  return r
}
const isOdd = n => n % 2 !== 0
const isEven = n => R.not(isOdd(n))
const isListOfEvenLength = R.compose(isEven, R.length)
const isListOfOddLength = R.compose(isOdd, R.length)

/**
 * Create a range with custom steps, for each pair of step, you will also
 * specify a jump.
 */
export default (steps, jumps) => {
  invariant(isListOfEvenLength(steps), "'steps' should be a list of even length")
  invariant(isListOfOddLength(jumps), "'jumps' should be a a list of odd length")
  invariant(R.length(steps) == R.length(jumps) + 1, "'steps' should have one element more than 'jumps'")
  invariant(R.length(steps) >= 2, "'steps' should be at least 2 elements long")

  const processStep = (step, index, steps) => {
    const lowBound = step
    const hightBound = steps[index+1]
    const jump = jumps[index]
    return range(lowBound, hightBound, jump)
  }
  return  R.flatten(steps.map(processStep))
}



/** WEBPACK FOOTER **
 ** ./app/utils/range.js
 **/